/**
 * @generated SignedSource<<2c6a61646cb66c3760eab59e35c336ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateRowFlightDetails_packageDate$data = {
  readonly flight: {
    readonly id: string;
    readonly lastUpdate: {
      readonly status: string | null;
    } | null;
    readonly priceLive: number;
    readonly " $fragmentSpreads": FragmentRefs<"FlightShortDetails_flight">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_packageDate">;
  readonly " $fragmentType": "PackageDateRowFlightDetails_packageDate";
};
export type PackageDateRowFlightDetails_packageDate$key = {
  readonly " $data"?: PackageDateRowFlightDetails_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlightDetails_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRowFlightDetails_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "flight",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceLive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FlightPrice",
          "kind": "LinkedField",
          "name": "lastUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlightShortDetails_flight"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "f1b9b05cd3a0011a06aace54ea556467";

export default node;
